export default __webpack_public_path__ + "static/media/img2.efcb86c1.png";